import { useTranslation } from "react-i18next";

export const Toggle = ({ label, value, onChange, testId }) => {
  const { t } = useTranslation();
  return (
    <div>
      <p className="label-xs mb-2">{label}</p>
      <div className="flex gap-2">
        {[true, false].map((option) => (
          <button
            key={String(option)}
            type="button"
            data-testid={`${testId}-${option ? "yes" : "no"}`}
            onClick={() => onChange(option)}
            className={`rounded-2xl bg-background px-4 py-2 text-xs font-bold transition-[box-shadow,color] duration-300 ${
              value === option
                ? "text-primary shadow-neu-in"
                : "text-muted-foreground shadow-neu-sm hover:text-foreground"
            }`}
          >
            {option ? t("app.yes") : t("app.no")}
          </button>
        ))}
      </div>
    </div>
  );
};
